
    <form autocomplete="off" [formGroup]="dadosConsultarLogradouro">

      <div class="modal-header">
        <h4 class="modal-title">{{titulo}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="ddlUF">UF</label> *
              <select class="form-control" id="ddlUF" name="ddlUF" formControlName="ddlUF" (change)="onSelecionarUF($event.target.value)">
                <option value="" selected>Selecione</option>
                <option *ngFor="let uf of ufs" [value]="uf">{{uf}}</option>
              </select>
            </div>
          </div>
          <div class="col-8">
            <div class="form-group">
              <label for="ddlMunicipio">Município</label> *
              <select class="form-control" id="ddlMunicipio" name="ddlMunicipio" formControlName="ddlMunicipio">
                <option value="" selected>Selecione</option>
                <option *ngFor="let municipio of municipios" [value]="municipio.municipioId">{{municipio.nome.trim()}}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="txtLogradouro">Logradouro</label> *
              <input type="text" class="form-control" id="txtLogradouro"
                name="txtLogradouro" formControlName="txtLogradouro" placeholder="Logradouro">
              <small id="logradouroHelp" class="form-text text-muted">Digite pelo menos três caracteres.</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group text-right">
              <button type="button" class="btn btn-primary" (click)="onModalConsultarCEP()" [disabled]="!podeConsultar">Pesquisar</button>
              <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Cancelar</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group" style="height: 200px; overflow-y: auto;" *ngIf="enderecos?.length">
              <table class="table table-striped table-hover" aria-describedby="Listagem endereços">
                <thead>
                  <tr>
                    <th>Logradouro</th>
                    <th>Bairro</th>
                    <th>Munic&iacute;pio</th>
                    <th>UF</th>
                    <th>CEP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let endereco of enderecos">
                    <td>{{endereco.logradouro}}</td>
                    <td>{{endereco.bairro}}</td>
                    <td>{{endereco.cidade}}</td>
                    <td>{{endereco.estado}}</td>
                    <td><span class="linkCEP" (click)="onSelecionarCEP(endereco)"><u>{{cepFormatado(endereco.cep)}}</u></span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <div class="modal-footer">
      </div>

    </form>
  


// WEBPACK FOOTER //
// ./src/app/shared/modal/ngbd-modal-content.ts.NgbdModalContent.html